import { TApmPaymentStatus } from '@payler/api/merchant-cabinet';

export const getApmSessionStatusBadgeVariant = (
  status: TApmPaymentStatus,
): string => {
  switch (status) {
    case 'Authorized':
    case 'Refunded':
      return 'green';
    case 'Rejected':
    case 'ProviderTechError':
    case 'Expired':
    case 'CanceledByCustomer':
      return 'red';
    default:
      return 'grey';
  }
};
